import { Box, Typography, useTheme } from '@mui/material';
import type Employee from '@src/Objects/Employee';
import { Briefcase } from 'lucide-react';
import React from 'react';

interface OverviewSectionsProps {
    employee: Employee;
}

function OverviewSections({ employee }: OverviewSectionsProps) {
    const theme = useTheme();
    // Find current active project
    const currentProject = employee.projects?.find((p) => p.active);

    return (
        <Box>
            {/* Current Project Section */}
            {currentProject && (
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: theme.palette.text.primary }}>
                        Aktuelles Projekt
                    </Typography>
                    <Box
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            backgroundColor: `${theme.palette.primary.main}08`,
                            border: `1px solid ${theme.palette.primary.main}20`,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                color: theme.palette.primary.main,
                                mt: 0.5,
                            }}
                        >
                            <Briefcase size={20} />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                {currentProject.title}
                            </Typography>
                            {currentProject.business && (
                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1 }}>
                                    {currentProject.business.title}
                                </Typography>
                            )}
                            <Typography
                                variant="caption"
                                sx={{
                                    color: theme.palette.success.main,
                                    backgroundColor: `${theme.palette.success.main}15`,
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: 1,
                                    fontWeight: 500,
                                }}
                            >
                                Aktiv
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default OverviewSections;
